import styled from 'styled-components'
import { STATICS } from '../../static'

export default function Description() {
  return (
    <DescriptionWrapper>
      <img alt={'background'} src={STATICS.VipCardBg} />
      <Title>Membership Privileges</Title>
      <Desc>
        1.Only members can participate in Mystery box campaigns.
        <br />
        2.Only members are eligible for IGO , acquiring computing power.
        <br />
        3.Members can participate in DAO governance.
        <br />
        4.Only members can get COCOS commissions.
        <br />
        5.Members will get irregularly scheduled incentives, giveaways or airdrops.
      </Desc>
    </DescriptionWrapper>
  )
}

export function PolygonDescription() {
  return (
    <DescriptionWrapper>
      <img alt={'background'} src={STATICS.VipCardBg} />
      <SoldOutDesc>Membership sold out. Stay tuned!</SoldOutDesc>
    </DescriptionWrapper>
  )
}

const DescriptionWrapper = styled.div`
  width: 1150px;
  height: 334px;
  background: linear-gradient(230deg, #0348c3 0%, #8238c9 100%);
  border-radius: 20px;
  margin-top: 47px;
  padding-top: 53px;
  padding-left: 45px;
  color: #fff;
  position: relative;
  img {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`
const Title = styled.h3`
  font-size: 28px;
  line-height: 34px;
`
const Desc = styled.p`
  font-size: 14px;
  line-height: 30px;
  margin-top: 16px;
  max-width: 506px;
`

const SoldOutDesc = styled.div`
  margin-top: 60px;
  margin-left: 20px;
  font-size: 40px;
  color: #fff;
  width: 400px;
  text-align: center;
`
